import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { UserService } from '../../authentication/user.service';
import { LocalUserService } from '../../authentication/local-user.service';

var misc:any ={
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {

    public search_term: String = "";

    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;

    @ViewChild("navbar-cmp") button;

    constructor(location:Location,
        private router: Router,
        private userService: UserService,
        private localUser: LocalUserService,
        private renderer : Renderer,
        private element : ElementRef ) {

        this.location = location;
        this.nativeElement = element.nativeElement;
    }

    ngOnInit(){

        this.listTitles = ROUTES.filter(listTitle => listTitle);

        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if($('body').hasClass('sidebar-mini')){
            misc.sidebar_mini_active = true;
        }
        $('#minimizeSidebar').click(this.minimizeSidebar);

        if(!this.localUser.user._id){
            this.localUser.getSignedInUser(() => {
                if(this.localUser.user.minimizedSidebar){
                    this.minimizeSidebar();
                }
            })
        }
        else{
            if(this.localUser.user.minimizedSidebar)
                this.minimizeSidebar();
        }
    }

    minimizeSidebar(){
        if(misc.sidebar_mini_active == true){
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;
            }
            else{
                setTimeout(function(){
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                },300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function(){
                window.dispatchEvent(new Event('resize'));
            },180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function(){
                clearInterval(simulateWindowResize);
            },1000);
    }

    isMobileMenu(){
        if($(window).width() < 991){
            return false;
        }
        return true;
    }

    sidebarOpen(){
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        },500);
        body.classList.add('nav-open');
        this.localUser.user.minimizedSidebar = true;
    }

    sidebarClose(){
        var body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.localUser.user.minimizedSidebar = false;
        body.classList.remove('nav-open');
    }

    sidebarToggle(){
        // var toggleButton = this.toggleButton;
        // var body = document.getElementsByTagName('body')[0];
        if(this.localUser.user.minimizedSidebar == false){
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    toggleMinimized(){
        this.userService.toggleMinimized().subscribe(data => {}, error => {});
    }

    getTitle(){

        var titlee = this.location.prepareExternalUrl(this.location.path());
        if(titlee.charAt(0) === '#'){
            titlee = titlee.slice( 2 );
        }
        for(var item = 0; item < this.listTitles.length; item++){
            var parent = this.listTitles[item];
            if(parent.path === titlee){
                return parent.title;
            }else if(parent.children){
                var children_from_url = titlee.split("/")[2];
                for(var current = 0; current < parent.children.length; current++){
                    if(parent.children[current].path === children_from_url ){
                        return parent.children[current].title;
                    }
                }
            }
        }
        if(titlee.split("/")[2] == "recherche")
            return "Recherche...";

        return 'Dashboard';
    }

    getPath(){
        
        return this.location.prepareExternalUrl(this.location.path());
    }

    gotToSearch(valid: boolean){

        if(valid){

            this.router.navigate(['compte', 'recherche', this.search_term]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts